import { FormattedMessage } from 'react-intl';
import messages from './messages';
import { DEFAULT_APPROVED_AMOUNT_COLUMN_WIDTH } from '../constants';

export const HEADERS = [
  {
    id: 'claimType',
    label: <FormattedMessage {...messages.claimType} />,
    dataType: 'string',
    sortable: true,
    searchable: true,
    multiselect: true,
  },
  {
    id: 'hudClaimId',
    label: <FormattedMessage {...messages.claimId} />,
    dataType: 'string',
    sortable: true,
    searchable: true,
  },
  {
    id: 'requestedAmount',
    label: <FormattedMessage {...messages.requestedAmount} />,
    dataType: 'number',
    sortable: true,
    searchable: true,
  },
  {
    id: 'approvedAmount',
    label: <FormattedMessage {...messages.approvedAmount} />,
    dataType: 'number',
    defaultWidth: DEFAULT_APPROVED_AMOUNT_COLUMN_WIDTH,
    sortable: true,
    searchable: true,
  },
  {
    id: 'propertyTransactionCodeId',
    label: <FormattedMessage {...messages.chargeCode} />,
    dataType: 'string',
    sortable: true,
    searchable: true,
    multiselect: true,
  },
  {
    id: 'actions',
    label: <FormattedMessage {...messages.actions} />,
  },
];

export const PROPERTY_PATH_MAP = {
  claimType: {
    path: 'claimTypeDisplay',
    dataType: 'string',
  },
  hudClaimId: {
    path: 'hudClaimId',
    dataType: 'string',
  },
  requestedAmount: {
    path: 'requestedAmount',
    dataType: 'number',
  },
  approvedAmount: {
    path: 'approvedAmount',
    dataType: 'number',
  },
  propertyTransactionCodeId: {
    path: 'propertyTransactionCodeDisplay',
    dataType: 'string',
  },
  actions: {
    path: 'actions',
    dataType: 'string',
  },
};

export const CLAIM_TYPE_OPTIONS = [
  { value: 'unpaid_rent', text: 'Unpaid Rent -1' },
  { value: 'damages', text: 'Damages -2' },
  { value: 'rent_up_vacancy', text: 'Rent-Up Vacancy -3' },
  { value: 'regular_vacancy', text: 'Regular Vacancy -4' },
  { value: 'debt_service', text: 'Debt Service -5' },
];

export const getClaimTypeLabel = (value) => {
  if (!value) return '';

  const match = CLAIM_TYPE_OPTIONS.find((opt) => opt.value === value);
  return match?.text ?? String(value);
};

export const getSpecialClaimStatusLabel = (status) => {
  const normalized = (status || '').toString().toLowerCase().trim();

  if (normalized === 'not_submitted' || normalized === 'not submitted')
    return 'Not Submitted';
  if (normalized === 'submitted') return 'Submitted';
  if (normalized === 'successful' || normalized === 'success') return 'Success';
  if (normalized === 'error') return 'Error';
  if (status) return status;
  return '';
};
